///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.roles = abcsetup.roles || {};
abcsetup.roles.delegate = abcsetup.roles.delegate || {};
abcsetup.roles.delegate.index = abcsetup.roles.delegate.index || {};




///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.roles.delegate.index = {
    init: function() {
        abcsetup.setTitle('Delegate Roles');

        // Remove delegation button clicked
        $(document).on('click', '.remove-delegation', function (e) {
            $(this).hide();
            $(this).closest('.form-group').find(':input').val('');
            return false;
        });
    }
}
